import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EncounterData } from '../../../../models';

@Component({
  selector: 'app-encounter-section',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './encounter-section.component.html',
})
export class EncounterSectionComponent {
  readonly encounter = input.required<EncounterData>();

  formatDate(date: string): string {
    if (!date) return '—';
    return /^\d{4}-\d{2}-\d{2}/.test(date) ? date.slice(0, 10) : date;
  }

  getClaseBadge(codigo: string): { color: string; label: string } {
    const c = (codigo || '').toUpperCase();
    if (c === 'IMP') return { color: 'bg-danger', label: 'Hospitalización' };
    if (c === 'AMB') return { color: 'bg-success', label: 'Ambulatorio' };
    if (c === 'EMER') return { color: 'bg-warning text-dark', label: 'Urgencias' };
    if (c === 'VR') return { color: 'bg-info', label: 'Virtual' };
    return { color: 'bg-secondary', label: codigo || 'N/A' };
  }

  getStatusBadge(status: string): { color: string; label: string } {
    const s = (status || '').toLowerCase();
    if (s === 'finished' || s === 'completed') return { color: 'bg-success', label: 'Finalizado' };
    if (s === 'in-progress' || s === 'active') return { color: 'bg-primary', label: 'En Progreso' };
    if (s === 'planned') return { color: 'bg-warning text-dark', label: 'Planificado' };
    if (s === 'cancelled') return { color: 'bg-danger', label: 'Cancelado' };
    return { color: 'bg-secondary', label: status || 'N/A' };
  }

  getDxTipoBadge(tipoCodigo: string): string {
    const c = (tipoCodigo || '').toUpperCase();
    if (c === 'AD' || c === 'CC') return 'bg-danger';
    if (c === 'CM') return 'bg-warning text-dark';
    if (c === 'DD') return 'bg-info';
    return 'bg-secondary';
  }
}
